var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('input',{attrs:{"id":"","type":"file","name":""},on:{"change":_vm.loadImg}}),(_vm.uploadDialog)?_c('image-cropper',{attrs:{"image":_vm.img},on:{"close":function($event){_vm.uploadDialog = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }